import type { FaireProductEntity } from "../../entity_types/product";

export const p_1uup1tpwx5: FaireProductEntity = {
  token: "p_1uup1tpwx5",
  type: "product",
  name: "Harbor Mist Taupe Knotted Gown",
  brandToken: "b_3pci2bfmjr",
  brandName: "Three Little Tots",
  imageUrl:
    "https://cdn.faire.com/fastly/5eb44defceb51e03221349d442cc698c13a9de3b2358de60db70d6daea73bd90.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9cf8d16fd0c772335b42691fd1da5a6ee331f6d235431aa6f821ee5987518197.jpeg",
    "https://cdn.faire.com/fastly/179a1c9e93d3a67d265df29456f1cca37167478a48fdea9c39b9c3565d92feff.jpeg",
    "https://cdn.faire.com/fastly/6a4539183c6d2a3d6e61d01222cdadb5f87e45389713eff607582eb07cef9da0.jpeg",
    "https://cdn.faire.com/fastly/b3718923a98f4557a22a907f2091ee9420d3045f5d3794a29af8b385e3f754bc.jpeg",
    "https://cdn.faire.com/fastly/99c3b2c9406c083e6aa0204300420c288939753e272aeaf40407fce73a88ab26.jpeg",
    "https://cdn.faire.com/fastly/9b0c879efc1ae8eb7d9c4233e7ae04288806225134c3bc3cf9a7c8b447244f9e.jpeg",
    "https://cdn.faire.com/fastly/78b4f700583db8e46918351d26790de45efbf170b5c6099ed3d4e0ad96a67b2e.jpeg",
    "https://cdn.faire.com/fastly/2656f12326bf58f08c34740a5ddfbcf41481a36b813763851876404063751394.jpeg",
    "https://cdn.faire.com/fastly/f1ba04663fe0f0f95ff69f82d82a63b1de0a4caeffa2c03cce06341272458d3c.jpeg",
    "https://cdn.faire.com/fastly/ecbe4c2f6018875e1d72fbd4dc51def81b0cdf678d2785c6ce8d76b999114f25.jpeg",
    "https://cdn.faire.com/fastly/855c75036f6e53d1d35c076e04f3fa50d59de35bb2fa558b6aea20af6fbc68be.jpeg",
    "https://cdn.faire.com/fastly/74b2fe74f0822158f19113d85befa74de490d9fc9b7d099e3463ca84cbd0aa04.jpeg",
    "https://cdn.faire.com/fastly/d2aa49d204e7d0075c468df63cc2438e41876e36516563c1f94173226e84ae89.jpeg",
    "https://cdn.faire.com/fastly/f58a990a2c42d899bef8c4d8dab00bb19a434d0f45ccf9dbaaef92f4e9e0af1c.jpeg",
    "https://cdn.faire.com/fastly/a989e405e97a921cf661674181fc6a5926335fb7ba337355bfed029524b2a906.jpeg",
    "https://cdn.faire.com/fastly/792e8383ef3a927ff54b60952c022cf4d8c3e94d1020998becf59646f874af38.jpeg",
    "https://cdn.faire.com/fastly/29cf8aa1dc2f2fbe0e439bf0a42eaabb7f643dc036e3dc3e3d2da11391489c29.jpeg",
    "https://cdn.faire.com/fastly/845df21418a5866c15e03dac81072d304f4bcb5768a095c8defcfdf621f4432e.jpeg",
    "https://cdn.faire.com/fastly/886d832e12a7253ab25f1824739683040515a909df5642c41bc94207faf02b1d.jpeg",
    "https://cdn.faire.com/fastly/5d84cb2b3839b9a325105b9f4acc8e80e1ce490a46616767e6d78b9b1c00e407.jpeg",
    "https://cdn.faire.com/fastly/fd50b7ccabe6e1762a9c9708e11dbff2212e76622c6abd07a6e4480d22c564ba.jpeg",
    "https://cdn.faire.com/fastly/7e92341014a70605f1a806800348514854aa28e356a0bdbd6fa0f76d79f30d31.jpeg",
    "https://cdn.faire.com/fastly/50749e83b191e14ddf488b4a46bbfe856c28130ba987b5d8b2171d402a028e30.jpeg",
  ],
  priceDollars: 10.3,
  description:
    "These baby gowns are so soft you will never want your baby in anything else. Fabric is designed to be soft, comfortable, and stretchy. The tie bottom allows for an easy night-time diaper change. The pull-down tabs on the shoulder make it easy to dress and change. Newborn-3 month fits approx 5lbs-15lbs.",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:15.827Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
